/* eslint-disable no-console */
<template>
    <div>
        <div class="header_unit header_bg_white">
            <div class="header_box">
                <div class="menu_left">
                    <router-link class="icn_back_black top_tit" :to="{ name: 'managemenu'} ">
                        <p class="top_tit">＜戻る</p></router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_l top_tit">衛生管理計画書設定画面</p>
                </div>
            </div>
        </div>
        <HygieneManagementPlanSetting />
    </div>

</template>

<script>
    import HygieneManagementPlanSetting from '@/app/components/HygieneManagementPlanSetting.vue'
    export default {
        name: "ManageHygieneManagementPlanSetting",
        components: {
            HygieneManagementPlanSetting
        }
    }
</script>